import { css } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csColorBorder } from '@cloudsuite/mosaic-shared/styles/colors.style.js'


export const plannedDeliveryDates = css`
  :host {
    --cse-accordion-default-header-background-color: transparent;
    --cse-accordion-default-content-padding-y: 0;
    --cse-accordion-default-content-padding-x: 0;
  }

  cse-accordion {
    border-style: solid;
    border-color: ${csColorBorder.light};
    border-width: ${csSpacing.spacing00};
  }
`
